/**
 * Resize interactions for dashboard widgets on the editor canvas.
 */
const dashboardLayoutEditorCanvasResize = {
    /**
     * Start dashboard widget resize.
     *
     * @param {*} event
     * @param {*} block
     * @param {*} direction
     */
    startDashboardWidgetResize(event, block, direction) {
        event.preventDefault();
        event.stopPropagation();

        const canvasGrid = this.getDashboardCanvasGridElement();

        if (!canvasGrid) {
            return;
        }

        const rect = canvasGrid.getBoundingClientRect();

        this.dashboardCanvasResizeState = {
            referenceId: block.referenceId,
            direction,
            startX: event.clientX,
            startY: event.clientY,
            startColumnSpan: block.columnSpan,
            startRowSpan: block.rowSpan,
            startColumn: block.column,
            startRow: block.row,
            canvasWidth: rect.width,
            canvasHeight: rect.height,
        };

        document.body.style.cursor = direction.startsWith('horizontal') ? 'ew-resize' : 'ns-resize';

        window.addEventListener('mousemove', this.handleDashboardWidgetResize);
        window.addEventListener('mouseup', this.stopDashboardWidgetResize);
    },

    /**
     * Start dashboard block resize.
     *
     * @param {*} event
     * @param {*} block
     * @param {*} direction
     */
    startDashboardBlockResize(event, block, direction) {
        this.startDashboardWidgetResize(event, block, direction);
    },

    /**
     * Handle dashboard widget resize.
     *
     * @param {*} event
     */
    handleDashboardWidgetResize(event) {
        if (!this.dashboardCanvasResizeState) {
            return;
        }

        const columnWidth = this.dashboardCanvasResizeState.canvasWidth / this.dashboardGridColumns;
        const rowHeight = this.dashboardCanvasResizeState.canvasHeight / this.dashboardGridRows;
        const deltaColumns = Math.round((event.clientX - this.dashboardCanvasResizeState.startX) / columnWidth);
        const deltaRows = Math.round((event.clientY - this.dashboardCanvasResizeState.startY) / rowHeight);
        let columnSpan = this.dashboardCanvasResizeState.startColumnSpan;
        let rowSpan = this.dashboardCanvasResizeState.startRowSpan;
        let column = this.dashboardCanvasResizeState.startColumn;
        let row = this.dashboardCanvasResizeState.startRow;

        if (this.dashboardCanvasResizeState.direction === 'horizontal') {
            columnSpan = this.dashboardCanvasResizeState.startColumnSpan + deltaColumns;
        }

        if (this.dashboardCanvasResizeState.direction === 'vertical') {
            rowSpan = this.dashboardCanvasResizeState.startRowSpan + deltaRows;
        }

        if (this.dashboardCanvasResizeState.direction === 'horizontal-left') {
            const rightColumn = this.dashboardCanvasResizeState.startColumn
                + this.dashboardCanvasResizeState.startColumnSpan
                - 1;

            column = Math.min(Math.max(this.dashboardCanvasResizeState.startColumn + deltaColumns, 1), rightColumn);
            columnSpan = rightColumn - column + 1;
        }

        if (this.dashboardCanvasResizeState.direction === 'vertical-top') {
            const bottomRow = this.dashboardCanvasResizeState.startRow
                + this.dashboardCanvasResizeState.startRowSpan
                - 1;

            row = Math.min(Math.max(this.dashboardCanvasResizeState.startRow + deltaRows, 1), bottomRow);
            rowSpan = bottomRow - row + 1;
        }

        if (this.dashboardCanvasResizeState.direction === 'both') {
            columnSpan = this.dashboardCanvasResizeState.startColumnSpan + deltaColumns;
            rowSpan = this.dashboardCanvasResizeState.startRowSpan + deltaRows;
        }

        this.setDashboardWidgetBounds(this.dashboardCanvasResizeState.referenceId, {
            column,
            row,
        }, {
            columnSpan: Math.min(
                Math.max(columnSpan, 1),
                this.dashboardGridColumns - this.dashboardCanvasResizeState.startColumn + 1,
            ),
            rowSpan: Math.min(
                Math.max(rowSpan, 1),
                this.dashboardGridRows - this.dashboardCanvasResizeState.startRow + 1,
            ),
            direction: this.dashboardCanvasResizeState.direction,
        });
    },

    /**
     * Stop dashboard widget resize.
     */
    stopDashboardWidgetResize() {
        if (!this.dashboardCanvasResizeState) {
            return;
        }

        window.removeEventListener('mousemove', this.handleDashboardWidgetResize);
        window.removeEventListener('mouseup', this.stopDashboardWidgetResize);
        this.dashboardCanvasResizeState = null;
        document.body.style.cursor = '';
    },
};

export default dashboardLayoutEditorCanvasResize;
